import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ContractorDashboard from './pages/ContractorDashboard';
import OnboardingPage from './pages/OnboardingPage';
import AdminDashboard from './pages/AdminDashboard';

const AppRoutes = () => {
  const { user, loading, onboardingComplete } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  // Redirect logic based on auth status
  const getRedirectPath = () => {
    if (!user) return null;
    
    if (user.role === 'admin') {
      return '/admin/dashboard';
    } else if (!onboardingComplete) {
      return '/onboarding';
    } else {
      return '/dashboard';
    }
  };

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          user ? (
            <Navigate to={getRedirectPath() || '/dashboard'} replace />
          ) : (
            <LandingPage />
          )
        } 
      />
      <Route 
        path="/login" 
        element={
          user ? (
            <Navigate to={getRedirectPath() || '/dashboard'} replace />
          ) : (
            <LoginPage />
          )
        } 
      />
      <Route
        path="/register"
        element={
          user ? (
            <Navigate to={getRedirectPath() || '/dashboard'} replace />
          ) : (
            <RegisterPage />
          )
        }
      />

      {/* Contractor Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {user?.role === 'admin' ? (
              <Navigate to="/admin/dashboard" replace />
            ) : onboardingComplete ? (
              <ContractorDashboard />
            ) : (
              <Navigate to="/onboarding" replace />
            )}
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            {user?.role === 'admin' ? (
              <Navigate to="/admin/dashboard" replace />
            ) : onboardingComplete ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <OnboardingPage />
            )}
          </ProtectedRoute>
        }
      />

      {/* Admin Routes */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
